<!-- 新闻详情 -->

<template>
    <div class='content'>
        <div class="container" v-if="type == 1">
            <div class="title_box">
                <p>{{ info.announce_title }}</p>
            </div>
            <div class="time_box">
                <p>发布者：{{ info.publisher }}</p>
                <p>发布时间：{{ info.createtime }}</p>
            </div>
            <div class="ctn_box" v-html="info.publish_content"></div>
        </div>
        <div class="container" v-else>
            <div class="title_box">
                <p>{{ info.news_title }}</p>
            </div>
            <div class="time_box">
                <p>发布者：{{ info.publisher }}</p>
                <p>发布时间：{{ formatTime(info.createtime) }}</p>
            </div>
            <div class="ctn_box" v-html="info.news_content"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            id: "",
            type: 0,
            pageLoading: true,
            info: {}
        }
    },
    mounted() {
        this.id = this.$route.query.id || "";
        this.type = this.$route.query.type || 0;
        this.init();
    },
    methods: {
        // tianyue.com/api/index/announceDetail?id=1
        async init() {
            if (this.type == 1) {
                this.pageLoading = true;
                try {
                    const res = await this.$get('index/announceDetail', { id: this.id });
                    this.info = res.data || {};
                } catch (error) { }
                this.pageLoading = false;
            } else {
                this.pageLoading = true;
                try {
                    const res = await this.$get('index/newsDetail', { id: this.id });
                    this.info = res.data || {};
                } catch (error) { }
                this.pageLoading = false;
            }

        }
    },
}
</script>

<style lang='scss' scoped>
.content {
    padding: 56px 0 100px;

    .title_box {
        font-size: 30px;
        font-family: PingFang SC, PingFang SC-Heavy;
        font-weight: 800;
        color: #333333;
        line-height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .time_box {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: left;
        color: #999999;
        display: flex;
        align-items: center;
        margin: 12px 0 50px;
        justify-content: center;

        p:first-of-type {
            margin-right: 66px;
        }
    }

    .ctn_box {
        img {
            width: 100%;
        }
    }
}
</style>